import { ConditionalType } from '@/modules/ta/widget/widget.constants';

export function normalizeMetric(metric) {
  if (!metric) return null;
  const field = metric.field ?? metric.id ?? metric.name ?? null;
  if (!field) return null;
  return {
    field: String(field),
    label: String(metric.label ?? metric.name ?? field),
    format: metric.format ?? null,
  };
}

export function normalizeDataSource(ds) {
  if (!ds) return null;
  return {
    id: ds.id ?? null,
    name: ds.name ?? null,
    type: ds.type ?? null,
    color: ds.color ?? null,
    service_icon: ds.service_icon ?? null,
  };
}

export function normalizeDataView(dv) {
  if (!dv) return null;
  return {
    id: dv.id ?? null,
    name: dv.name ?? null,
  };
}

export class SalesConfig {
  constructor(salesConfig = {}) {
    this.data_source = normalizeDataSource(salesConfig?.data_source);
    this.data_view = normalizeDataView(salesConfig?.data_view);
    this.metrics = Array.isArray(salesConfig?.metrics)
      ? salesConfig.metrics.map(normalizeMetric).filter(Boolean)
      : [];
    this.sales_metric = normalizeMetric(salesConfig?.sales_metric);
    this.rules = {
      risk: {
        condition: salesConfig?.rules?.risk?.condition ?? ConditionalType.LESS_THAN,
        min: salesConfig?.rules?.risk?.min ?? null,
        max: salesConfig?.rules?.risk?.max ?? null,
        action: salesConfig?.rules?.risk?.action ?? null,
        reason: salesConfig?.rules?.risk?.reason ?? null,
      },
      upsell: {
        condition: salesConfig?.rules?.upsell?.condition ?? ConditionalType.GREATER_THAN,
        min: salesConfig?.rules?.upsell?.min ?? null,
        max: salesConfig?.rules?.upsell?.max ?? null,
        action: salesConfig?.rules?.upsell?.action ?? null,
        reason: salesConfig?.rules?.upsell?.reason ?? null,
      },
      renewal: {
        days: salesConfig?.rules?.renewal?.days ?? null,
        action: salesConfig?.rules?.renewal?.action ?? null,
      },
    };
  }
}
